module.exports = "/next-static/_next/static/images/hero_image_small-aca82e390635ce1a96f3e1ed55b7e15f.webp";